export var BREADCRUMBS_ADD = 'BREADCRUMBS_ADD';
export var BREADCRUMBS_UPDATE = 'BREADCRUMBS_UPDATE';
export var BREADCRUMBS_REMOVE = 'BREADCRUMBS_REMOVE';
export var BREADCRUMBS_REDUCER_NAME = 'breadcrumbs';